import type { IRange } from "app/pages/sales-intelligence/types/range";

export const isFilterRange = <T = unknown>(value: unknown): value is Partial<IRange<T>> => {
    return typeof value === "object" && value !== null && ("from" in value || "to" in value);
};
